import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarHeader,
  SidebarFooter,
} from '@/components/ui/sidebar';
import {
  FolderTree,
  Home,
  Package,
  ShoppingBag,
  Tag,
  Users,
  Store,
} from 'lucide-react';

const menuItems = [
  {
    title: 'Dashboard Principal',
    url: '/dashboard',
    icon: Home,
  },
];

const managementItems = [
  {
    title: 'Gerir Utilizadores',
    url: '/users-dashboard',
    icon: Users,
  },
  {
    title: 'Gerir Produtos',
    url: '/products-dashboard',
    icon: ShoppingBag,
  },
  {
    title: 'Gerir Categorias',
    url: '/category-dashboard',
    icon: FolderTree,
  },
  {
    title: 'Gerir Marcas',
    url: '/brands-dashboard',
    icon: Tag,
  },
  {
    title: 'Gerir Locais',
    url: '/locations-dashboard',
    icon: Store,
  },
  {
    title: 'Painel de Vendas',
    url: '/orders-dashboard',
    icon: Package,
  },
];


interface AdminSidebarProps {
  isHovered: boolean;
  onHoverChange: (hovered: boolean) => void;
}

export function AdminSidebar({ isHovered, onHoverChange }: AdminSidebarProps) {
  const location = useLocation();


  const isActive = (url: string) => {
    if (url.includes('?tab=')) {
      const [path, tab] = url.split('?tab=');
      return location.pathname === path && location.search.includes(`tab=${tab}`);
    }
    return location.pathname === url;
  };

  return (
    <Sidebar
      className="bg-brand-darker border-r border-brand-gray transition-[width] duration-500 ease-in-out group/sidebar"
      collapsible="none"
      style={{
        width: isHovered ? '200px' : '64px',
        minWidth: isHovered ? '200px' : '64px',
        maxWidth: isHovered ? '200px' : '64px'
      }}
      onMouseEnter={() => onHoverChange(true)}
      onMouseLeave={() => onHoverChange(false)}
    >
      <SidebarHeader className={`p-3 flex items-center transition-all duration-300 ${isHovered ? 'justify-start' : 'justify-center'}`}>
        <Link to="/dashboard" className="flex items-center min-w-0">
          <img
            src="/lovable-uploads/2024-10-logo-pt.png"
            alt="DartsBeat Store"
            className="flex-shrink-0 object-contain h-8 w-8"
          />
        </Link>
      </SidebarHeader>

      <SidebarContent className="text-white">
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton
                    asChild
                    isActive={isActive(item.url)}
                    className={`text-white hover:bg-brand-gray hover:text-white data-[active=true]:bg-brand-red data-[active=true]:text-white transition-colors duration-200 justify-start pl-2 pr-1 py-3`}
                    tooltip={!isHovered ? item.title : undefined}
                  >
                    <Link to={item.url} className="flex items-center w-full">
                      <item.icon className="flex-shrink-0 h-6 w-6" />
                      <span className={`transition-all duration-300 whitespace-nowrap text-white font-medium ${isHovered ? '!opacity-100 !ml-2 !inline-block !visible' : '!opacity-0 !w-0 !overflow-hidden !invisible'}`}>
                        {item.title}
                      </span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {managementItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton
                    asChild
                    isActive={isActive(item.url)}
                    className={`text-white hover:bg-brand-gray hover:text-white data-[active=true]:bg-brand-red data-[active=true]:text-white transition-colors duration-200 justify-start pl-2 pr-1 py-3`}
                    tooltip={!isHovered ? item.title : undefined}
                  >
                    <Link to={item.url} className="flex items-center w-full">
                      <item.icon className="flex-shrink-0 h-6 w-6" />
                      <span className={`transition-all duration-300 whitespace-nowrap text-white font-medium ${isHovered ? '!opacity-100 !ml-2 !inline-block !visible' : '!opacity-0 !w-0 !overflow-hidden !invisible'}`}>
                        {item.title}
                      </span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

      </SidebarContent>

      <SidebarFooter className="p-2">
        {/* Footer removed per user request */}
      </SidebarFooter>
    </Sidebar>
  );
}
